import React from 'react';
import { UsageBar } from 'components';
import { convertToPercentString } from 'utilities';

export default function UsageBarWrapper({ drmInfo, showExceedAllowanceError }) {
  /* and maps the print drm specific variables to their useage bar prop counterparts */

  const usageBarProps = {
    accordionLabel: (
      <>
        Print Usage
        <span className="noTranslate">
          {` ${convertToPercentString(drmInfo.currentPercent)}`}
        </span>
      </>
    ),
    hasAccordion: true,
    defaultExpanded: false,
    errorLabel: 'Exceeds print allowance',
    currentPercent: drmInfo.currentPercent,
    availablePercent: drmInfo.printPercentMaximum,
    newPercent: drmInfo.selectionPercent,
    remainingAllowance: drmInfo.printPercentMaximum - drmInfo.currentPercent,
    usageText: 'Previously Printed',
    alert: {
      isError: showExceedAllowanceError ? true : false,
      menu: 'print',
    },
  };
  return <UsageBar id="print-menu-drm" {...usageBarProps} />;
}
